<template>
  <b-overlay :show="loading" class="row bg-white ">
    <b-card title="Creación de lote">
      <b-form data-vv-scope="batch-form">
        <initial-section v-model="batch"/>
        <vs-divider />
        <div class="row">
          <div class="col-12">
            <h5>Sección jurídica</h5>
          </div>
          <div class="col-6">
            <b-form-group>
              <ListLegalQuality
                label="Calidad Jurídica (*)"
                v-model="batch.jurisdiction"
                v-on:change="validateJurisdiction"
                name="jurisdiction"
                v-validate="'required'"
                :danger="errors.has('batch-form.jurisdiction')"
                :danger-text="errors.first('batch-form.jurisdiction')"
                data-vv-as="calidad jurídica"
                :state="errors.has('batch-form.jurisdiction') ? false : null"
              />
              <b-form-invalid-feedback>
                {{ errors.first('batch-form.jurisdiction') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-6" v-if="batch.jurisdiction !== validations.abandon">
            <b-form-group label="Fecha de presunción (*)">
              <date-picker
                name="presumptionDate"
                v-model="batch.presumptionDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de presunción"
                placeholder="Fecha de presunción"
                v-validate="'required'"
                data-cy="presumption-date"
              />
              <div v-if="errors.has('batch-form.presumptionDate')">
                <small class="text-danger">
                  {{ errors.first('batch-form.presumptionDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-6" v-if="batch.jurisdiction !== validations.abandon">
            <b-form-group label="Fecha de incautación">
              <date-picker
                name="seizure-date"
                v-model="batch.seizureDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                placeholder="Fecha de incautación"
                data-cy="seizure-date"
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Causa Art. Ord. 136">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.law"
                  placeholder="Causa Art. Ord. 136"
                  name="law"
                />
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="validations.service.includes(batch.jurisdiction)">
          <div class="col-6">
            <b-form-group>
              <b-form-checkbox
                class="mt-5"
                v-model="batch.trade"
                name="trade"
              >
                Oficio
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-6" v-if="batch.trade">
            <b-form-group
              label="Fecha de oficio (*)"
            >
              <date-picker
                name="trade-date"
                v-model="batch.tradeDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de oficio"
                placeholder="Fecha de oficio"
                v-validate="{'required': batch.trade}"
                data-cy="trade-date"
              />
              <div v-if="errors.has('batch-form.trade-date')">
                <small class="text-danger">
                  {{ errors.first('batch-form.trade-date') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-6" v-if="batch.trade">
            <b-form-group label="Número de oficio">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.tradeNumber"
                  placeholder="Número de oficio"
                  name="tradeNumber"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6" v-if="batch.trade">
            <b-form-group label="Aduana de oficio">
              <v-select
                name="divisionId"
                v-model="batch.tradeCustom"
                :options="lotteryCustoms"
                :reduce="option => option.id"
                placeholder="Aduana de oficio"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="batch.jurisdiction === validations.abandon">
          <div class="col-12">
            <h5>Información de Presunción de abandono</h5>
          </div>
          <div class="col-6">
            <b-form-group
              label="Manifiesto Nro (*)"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.manifestNumber"
                  placeholder="Manifiesto Nro"
                  maxlength="45"
                  v-validate="{'required': batch.jurisdiction === validations.abandon}"
                  name="manifestNumber"
                  data-vv-as="manifiesto número"
                  :state="errors.has('batch-form.manifestNumber') ? false : null"
                />
              </b-input-group>
              <b-form-invalid-feedback>
                {{ errors.first('batch-form.manifestNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Fecha de manifiesto (*)"
            >
              <date-picker
                name="manifestDate"
                v-model="batch.manifestDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de manifiesto"
                placeholder="Fecha de manifiesto"
                v-validate="{'required': batch.jurisdiction === validations.abandon}"
                data-cy="manifest-date"
              />
              <div v-if="errors.has('batch-form.manifestDate')">
                <small class="text-danger">
                  {{ errors.first('batch-form.manifestDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Fecha de presunción (*)"
            >
              <date-picker
                name="presumptionDate"
                v-model="batch.presumptionDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de presunción"
                placeholder="Fecha de presunción"
                v-validate="{'required': batch.jurisdiction === validations.abandon}"
                @input="calculateBallotDate"
                data-cy="presumption-date-two"
              />
              <div v-if="errors.has('batch-form.presumptionDate')">
                <small class="text-danger">
                  {{ errors.first('batch-form.presumptionDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Número de papeleta de recepción">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  maxlength="45"
                  type="number"
                  v-model="batch.ballotNumber"
                  placeholder="Número de papeleta de recepción"
                  name="ballotNumber"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Fecha de papeleta"
            >
              <date-picker
                name="ballotDate"
                v-model="batch.ballotDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de papeleta"
                placeholder="Fecha de papeleta"
                @input="calculatePresumptionDate"
                data-cy="ballot-date"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="batch.jurisdiction === validations.pending">
          <div class="col-12">
            <h5>Información de Causa Legal Pendiente</h5>
          </div>
          <div class="col-6">
            <b-form-group label="Número de causa (*)">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  maxlength="45"
                  v-model="batch.causeNumber"
                  placeholder="Número de causa"
                  name="causeNumber"
                  v-validate="{'required': batch.jurisdiction === validations.pending}"
                  data-vv-as="número de causa"
                  :state="errors.has('batch-form.causeNumber') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('batch-form.causeNumber') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Nombre del juzgado (*)">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="AwardIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.courtName"
                  placeholder="Nombre del juzgado"
                  name="courtName"
                  v-validate="{'required': batch.jurisdiction === validations.pending}"
                  data-vv-as="nombre del juzgado"
                  :state="errors.has('batch-form.courtName') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('batch-form.courtName') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div
          class="row"
          v-if="validations.resolution.includes(batch.jurisdiction) || batch.confiscation"
        >
          <div class="col-12">
            <h5>Resolución</h5>
          </div>
          <div class="col-6">
            <b-form-group label="Número de resolución (*)">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  maxlength="45"
                  v-model="batch.resolutionNumber"
                  placeholder="Número de resolución"
                  v-validate="{'required': validations.resolution
                  .includes(batch.jurisdiction) || batch.confiscation}"
                  name="resolutionNumber"
                  data-vv-as="número de resolución"
                  :state="errors.has('batch-form.resolutionNumber') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('batch-form.resolutionNumber') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Fecha de resolución (*)"
            >
              <date-picker
                name="resolutionDate"
                v-model="batch.resolutionDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de resolución"
                placeholder="Fecha de resolución"
                v-validate="{'required': validations.resolution
                  .includes(batch.jurisdiction) || batch.confiscation}"
                data-cy="resolution-date"
              />
              <div v-if="errors.has('batch-form.resolutionDate')">
                <small class="text-danger">
                  {{ errors.first('batch-form.resolutionDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
        </div>
        <vs-divider />
        <div class="row">
          <div class="col-12">
            <h5>Sección mercancía</h5>
          </div>
          <div class="col-6">
            <b-form-group label="Consignatario">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="BookmarkIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.consignee"
                  placeholder="Consignatario"
                  name="consignee"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Fecha de loteo (*)"
            >
              <date-picker
                name="releaseDate"
                v-model="batch.releaseDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                data-vv-as="fecha de loteo"
                placeholder="Fecha de loteo"
                v-validate="'required'"
                :disabled-date="disabledMaxDate"
                data-cy="release-date"
              />
              <div v-if="errors.has('batch-form.releaseDate') ">
                <small class="text-danger">
                  {{ errors.first('batch-form.releaseDate') }}
                </small>
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Ubicación de mercancía (*)">
              <SelectValidate
                v-model="batch.location"
                :options="optionsLocation"
                name="location"
                v-validate="'required'"
                data-vv-as="ubicación de mercancía"
                :danger="errors.has('batch-form.location')"
                :danger-text="errors.first('batch-form.location')"
                :state="errors.has('batch-form.location') ? false : null"
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Calidad de mercancía (*)">
              <SelectValidate
                v-model="batch.quality"
                :options="optionsQuality"
                name="quality"
                v-validate="'required'"
                :danger="errors.has('batch-form.quality')"
                :danger-text="errors.first('batch-form.quality')"
                data-vv-as="calidad de mercancía"
                :state="errors.has('batch-form.quality') ? false : null"
              />
            </b-form-group>
          </div>
        </div>
        <vs-divider />
        <div class="row">
          <div class="col-12">
            <h5>Visto bueno</h5>
          </div>
          <div class="col-2">
            <b-form-group>
              <b-form-checkbox
                class="mt-5"
                v-model="batch.check"
                name="checkApproval"
              >
                Requiere visto bueno
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-3" v-if="batch.check">
            <b-form-group label="Número de certificado (*)">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HashIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="batch.certificateNumber"
                  placeholder="Número de certificado"
                  name="certificateNumber"
                  type="number"
                  data-vv-as="número de certificado"
                  v-validate="{ 'required': batch.certificateNumber }"
                  :state="errors.has('batch-form.certificateNumber') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('batch-form.certificateNumber') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-3" v-if="batch.check">
            <b-form-group
              label="Fecha de visto bueno"
            >
              <date-picker
                name="checkDate"
                v-model="batch.checkDate"
                class="w-100"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                placeholder="Fecha de visto bueno"
                data-cy="check-date"
              />
            </b-form-group>
          </div>
          <div class="col-4" v-if="batch.check">
            <b-form-group label="Entidad visto bueno (*)">
              <SelectValidate
                v-model="batch.entityCheck"
                :options="optionsEntityCheck"
                name="entityCheck"
                data-vv-as="entidad visto bueno"
                v-validate="{ 'required': batch.check }"
                :state="errors.has('batch-form.entityCheck') ? false : null"
                :danger="errors.has('batch-form.entityCheck')"
                :danger-text="errors.first('batch-form.entityCheck')"
              />
            </b-form-group>
          </div>
        </div>
        <vs-divider />
        <div class="row">
          <div class="col-12">
            <h5>Sección montos y derechos</h5>
          </div>
          <div class="col-3">
            <b-form-group label="Valor aduanero (*)">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <small class="font-weight-bold">USD</small>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="batch.customsAmount"
                  placeholder="Valor aduanero"
                  v-validate="'required'"
                  @change="calculateTax()"
                  name="customsAmount"
                  data-vv-as="valor aduanero"
                  :state="errors.has('batch-form.customsAmount') ? false : null"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('batch-form.customsAmount') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-3">
            <b-form-group label="Derechos arancelarios">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <small class="font-weight-bold">USD</small>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="batch.lawsAmount"
                  placeholder="Derechos arancelarios"
                  name="lawsAmount"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-3">
            <b-form-group label="Tipo de cambio">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <small class="font-weight-bold">CLP</small>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="batch.exchangeAmount"
                  placeholder="Tipo de cambio"
                  name="exchangeAmount"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-3">
            <b-form-group label="Monto mínimo">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <small class="font-weight-bold">CLP</small>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="batch.minimunAmount"
                  placeholder="Monto mínimo"
                  name="minimumAmount"
                  data-vv-as="monto mínimo"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Impuestos Adicionales"
            >
              <v-select
                v-model="batch.additional"
                :options="optionsAdditional"
                name="additional"
              />
            </b-form-group>
          </div>
        </div>
        <vs-divider />
        <div class="row">
          <h5 class="col-12">
            Sección detalle del lote
          </h5>
          <div class="col-6">
            <b-form-group>
              <ListBatchClassification
                label="Clasificación del lote (*)"
                v-model="batch.clasification"
                name="classification"
                :danger="errors.has('batch-form.classification')"
                :danger-text="errors.first('batch-form.classification')"
                v-validate="'required'"
                data-vv-as="clasificación del lote"
              />
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group label="Tipo de medida (*)">
              <SelectValidate
                v-model="batch.measure"
                :options="optionsMeasure"
                name="measure"
                :danger="errors.has('batch-form.measure')"
                :danger-text="errors.first('batch-form.measure')"
                :state="errors.has('batch-form.measure') ? false : null"
                v-validate="'required'"
                data-vv-as="tipo de medida"
              />
            </b-form-group>
          </div>
          <div class="col-2">
            <b-form-group label="Peso (*)">
              <b-form-input
                v-model="batch.weight"
                placeholder="Peso"
                data-vv-as="peso"
                name="weight"
                type="number"
                v-validate="'required'"
                :state="errors.has('batch-form.weight') ? false : null"
              />
              <b-form-invalid-feedback>
                {{ errors.first('batch-form.weight') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group label="Unidad de medida (*)">
              <SelectValidate
                v-model="batch.measureUnit"
                :options="optionsMeasureUnit"
                data-vv-as="unidad de medida"
                name="measureUnit"
                v-validate="'required'"
                :state="errors.has('batch-form.measureUnit') ? false : null"
                :danger="errors.has('batch-form.measureUnit')"
                :danger-text="errors.first('batch-form.measureUnit')"
              />
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group label="Núm de Lote interno (*)">
              <b-form-input
                v-model="batch.internBatch"
                placeholder="Núm de Lote interno"
                data-vv-as="núm de lote interno"
                name="internBatch"
                type="number"
                v-validate="'required'"
                :state="errors.has('batch-form.internBatch') ? false : null"
              />
              <b-form-invalid-feedback>
                {{ errors.first('batch-form.internBatch') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <label>Descripción del lote (*)</label>
            <b-form-textarea
              placeholder="Escriba aquí la descripción del lote"
              v-model="batch.description"
              rows="4"
              max
              maxlength="5000"
              name="description"
              v-validate="'required'"
              :state="errors.has('batch-form.description') ? false : null"
            />
            <b-form-invalid-feedback>
              {{ errors.first('batch-form.description') }}
            </b-form-invalid-feedback>
            <small
              class="textarea-counter-value float-right"
              :class="batch.description.length >= maxChar ? 'bg-danger' : ''"
            >
              <span class="char-count">{{ batch.description.length }}</span> / {{ maxChar }}
            </small>
          </div>
          <div class="col-12">
            <label>Datos adicionales internos (*)</label>
            <b-form-textarea
              :placeholder="placeholderAddData"
              v-model="batch.descriptionInvoice"
              rows="4"
              max
              maxlength="1000"
              name="descriptionInvoice"
              data-vv-as="datos adicionales internos"
              v-validate="'required'"
              :state="errors.has('batch-form.descriptionInvoice') ? false : null"
            />
            <b-form-invalid-feedback>
              {{ errors.first('batch-form.descriptionInvoice') }}
            </b-form-invalid-feedback>
            <small
              class="textarea-counter-value float-right"
              :class="batch.descriptionInvoice.length >= maxChar ? 'bg-danger' : ''"
            >
              <span class="char-count">{{ batch.descriptionInvoice.length }}</span> / {{ maxChar2 }}
            </small>
          </div>
          <div class="col-12" v-if="!editBatch">
            <div class="row">
              <div class="col-4">
                <UploadFile
                  permission="*"
                  text="Seleccionar imagen"
                  accept=".jpg,.png"
                  :max-size-in-mb="30"
                  v-model="additionalImage"
                  :upload-to="urlFile"
                  button-class="btn-block"
                  container-class="w-100"
                  @input="addAdditionalFile()"
                />
              </div>
              <div class="col-12 mt-3" v-if="batch.images.length">
                <b-table-simple hover small>
                  <b-thead>
                    <b-tr>
                      <b-th scope="col">Nombre archivo</b-th>
                      <b-th scope="col">Principal</b-th>
                      <b-th scope="col" class="text-center">-</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-if="batch.images.length">
                    <b-tr v-for="file in batch.images" :key="file.id">
                      <b-td>
                        <div class="d-flex align-items-center">
                          <vs-icon icon="file_present" size="medium" class="mr-1"/>
                          {{file.name}}
                        </div>
                      </b-td>
                      <b-td class="text-center">
                        <vs-checkbox
                          v-on:change="markPrincipalImage(file)"
                          class="ml-5 pl-5" v-model="file.principal"
                        />
                      </b-td>
                      <b-td class="text-center">
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="removeAdditionalFile(file.id)"
                        >
                          remover
                        </b-button>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-right  mt-5">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            @click="cancelBatch"
          >
            Cancelar
          </b-button>
          <b-button
            variant="outline-info"
            class="mr-2"
            @click="previewBatch()"
            data-cy="preview"
          >
            Previsualizar
          </b-button>
          <b-button
            variant="outline-warning"
            class="mr-2"
            data-cy="draft"
            v-if="batch.status === '' || batch.status === batchesCodeSates.borrador"
            @click="processBatch(batchesCodeSates.borrador)"
          >
            Guardar como borrador
          </b-button>
          <b-button
            variant="success"
            @click="processBatch(batchesCodeSates.creado)"
            data-cy="next-button"
          >
            Guardar
          </b-button>
        </div>
      </b-form>
    </b-card>
  </b-overlay>
</template>
<script>

import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import InitialSection from '@/febos/aduanas/batches/views/components/InitialSection';
import { legalQualities, batchClassification } from '@/febos/aduanas/batches/store/getters';
import { attemptProcessBatch, attemptUpdateBatch } from '@/febos/aduanas/batches/store/actions';
import { measureoptions } from '@/febos/aduanas/batches/config/measure';
import { measureUnitOptions } from '@/febos/aduanas/batches/config/measureUnit';
import { optionsQuality } from '@/febos/aduanas/batches/config/quality';
import ListLegalQuality from '@/febos/aduanas/batches/views/components/lists/ListLegalQuality';
import { validations } from '@/febos/aduanas/batches/config/jurisdiction';
import { additionaloptions } from '@/febos/aduanas/batches/config/additional';
import ListBatchClassification from '@/febos/aduanas/batches/views/components/lists/ListBatchClassification';
import SelectValidate from '@/febos/chile/_vue/componentes/SelectValidate';
import { ioGetHoldingGroupsCompanies } from '@/febos/servicios/api/v2.companies.api';
import { getConfigurationParameters } from '@/febos/servicios/api/v2.herramientas.api';
import { NO_APPROVAL_REQUIRED, YES_APPROVAL_REQUIRED, batchesCodeSates } from '@/febos/aduanas/batches/views/utils/constants';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { getBatch } from '@/febos/servicios/api/aduanas/batches.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  components: {
    InitialSection,
    ListLegalQuality,
    ListBatchClassification,
    SelectValidate,
    UploadFile,
    DatePicker
  },
  data() {
    return {
      loading: false,
      urlFile: `febos-io/temporal/${process.env.VUE_APP_AMBIENTE}/aduanas/lotes/`,
      error: {
        message: ''
      },
      batchesCodeSates,
      additionalImage: {},
      batchImages: [],
      maxDate: this.$moment().format('YYYY-MM-DD'),
      lotteryCustoms: [],
      editBatch: false,
      maxChar: 5000,
      maxChar2: 1000,
      qualityTax: '',
      optionsAdditional: additionaloptions,
      optionsEntityCheck: [],
      validations,
      optionsMeasure: measureoptions,
      optionsMeasureUnit: measureUnitOptions,
      optionsLocation: [],
      optionsQuality,
      needCompleteForm: false,
      placeholderAddData: 'Escriba aquí los datos adicionales internos que después se verán en la factura',
      batch: {
        status: '',
        images: [],
        trade: false,
        tradeDate: '',
        tradeNumber: '',
        tradeCustom: '',
        causeNumber: '',
        courtName: '',
        manifestDate: '',
        manifestNumber: '',
        ballotNumber: '',
        ballotDate: '',
        resolutionDate: '',
        resolutionNumber: '',
        confiscation: false,
        additionalResolution: false,
        jurisdiction: '',
        presumptionDate: '',
        seizureDate: '',
        law: '',
        consignee: '',
        releaseDate: '',
        location: '',
        check: false,
        certificateNumber: '',
        checkDate: '',
        entityCheck: '',
        customsAmount: '',
        lawsAmount: '',
        exchangeAmount: '',
        minimunAmount: '0',
        clasification: '',
        measure: '',
        weight: '',
        measureUnit: '',
        internBatch: '',
        description: '',
        descriptionInvoice: '',
        additional: ''
      }
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'batch.quality': function () {
      const { quality } = this.batch;
      const found = Object.keys(this.configurations)
        .filter((key) => key.includes((quality).toLowerCase()));
      this.qualityTax = this.configurations[found];
    }
  },
  computed: {
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('batches', {
      legalQualities: legalQualities.name,
      batchClassification: batchClassification.name
    }),
    keepStatus() {
      return (this.batch.status
        && this.batch.status !== this.batchesCodeSates.borrador
        && this.batch.status !== this.batchesCodeSates.creado);
    }
  },
  methods: {
    ...mapActions('batches', {
      attemptProcessBatch: attemptProcessBatch.name,
      attemptUpdateBatch: attemptUpdateBatch.name
    }),
    disabledMaxDate(date) {
      const today = this.$moment().format('YYYY-MM-DD');
      const dateCalendar = this.$moment(date).format('YYYY-MM-DD');
      return dateCalendar > today;
    },
    changeDraftToCreated(newStatus) {
      return (this.batch.status === this.batchesCodeSates.borrador
        && newStatus === this.batchesCodeSates.creado);
    },
    markPrincipalImage(file) {
      this.batch.images = this.batch.images.map((image) => {
        let img = image;
        if (image.id === file.id) {
          img = {
            ...image,
            principal: true
          };
          return img;
        }
        return {
          ...image,
          principal: false
        };
      });
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalImage).length) {
        return;
      }

      if (this.additionalImage.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.batch.images.push(this.additionalImage);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.batch.images = this.batch.images.filter((file) => file.id !== fileId);
    },
    calculateTax() {
      this.batch.lawsAmount = (parseFloat(this.batch.customsAmount) * this.qualityTax) / 100;
    },
    calculatePresumptionDate() {
      const date = Vue.moment(this.batch.ballotDate);
      this.batch.presumptionDate = Vue.moment(date).add(90, 'days').format('YYYY-MM-DD');
    },
    calculateBallotDate() {
      const date = Vue.moment(this.batch.presumptionDate);
      this.batch.ballotDate = Vue.moment(date).subtract(90, 'days').format('YYYY-MM-DD');
    },
    validateJurisdiction() {
      if (this.batch.jurisdiction === this.validations.confiscation) {
        this.batch.confiscation = true;
      }
    },
    optionSelected(array, selected) {
      return array.find((option) => option.value === selected);
    },
    async processBatch(batchStatus, isPreview) {
      if (batchStatus !== this.batchesCodeSates.borrador) {
        const isValid = await this.$validator.validateAll('batch-form');
        if (!isValid) {
          this.$vs.notify({
            title: 'Error',
            text: 'Por favor llena todos los campos para continuar',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: ALERT_POSITION
          });
          return;
        }
      }
      this.loading = true;
      const jurisdiction = this.optionSelected(this.legalQualities.list, this.batch.jurisdiction);
      const classification = this.optionSelected(
        this.batchClassification.list, this.batch.clasification
      );
      const measure = this.optionSelected(this.optionsMeasure, this.batch.measure);
      const measureUnit = this.optionSelected(this.optionsMeasureUnit, this.batch.measureUnit);
      const location = this.optionSelected(this.optionsLocation, this.batch.location);
      const quality = this.optionSelected(this.optionsQuality, this.batch.quality);

      let images = [];
      if (this.batch.images.length) {
        images = this.batch.images.map((img, index) => ({
          urlTemporal: img.path,
          prioridad: img.principal ? 1 : (index + 1) + 1,
          nombre: img.name
        }));
      }
      let newStatus;
      if (this.changeDraftToCreated(batchStatus)) {
        newStatus = this.batchesCodeSates.creado;
      } else if (this.keepStatus) {
        newStatus = this.batch.status;
      } else {
        newStatus = batchStatus;
      }
      const batch = {
        ...(this.company.id && { gestoraId: this.company.id }),
        ...(jurisdiction && jurisdiction.value && {
          calidadJuridicaId: jurisdiction.value,
          calidadJuridicaNombre: jurisdiction.label,
          calidadJuridicaCodigo: jurisdiction.value
        }),
        requiereVb: this.batch.check ? YES_APPROVAL_REQUIRED : NO_APPROVAL_REQUIRED,
        ...(classification && classification.id && {
          clasificacionLoteId: classification.id,
          clasificacionLoteValor: classification.value,
          clasificacionLoteDescripcion: classification.label
        }),
        ...(measure && measure.id && {
          tipoMedidaId: measure.id,
          tipoMedidaValor: measure.value,
          tipoMedidaDescripcion: measure.label
        }),
        ...(this.batch.weight && { pesoLote: parseInt(this.batch.weight, 10) }),
        ...(measureUnit && measureUnit.id && {
          unidadMedidaId: measureUnit.id,
          unidadMedidaValor: measureUnit.value,
          unidadMedidaDescripcion: measureUnit.label
        }),
        ...(this.batch.internBatch && { numeroInterno: parseInt(this.batch.internBatch, 10) }),
        ...(this.batch.description && { descripcionLote: this.batch.description }),
        ...(this.batch.descriptionInvoice
          && { descripcionLoteFactura: this.batch.descriptionInvoice }),
        ...(this.batch.customsAmount && { valorAduanero: parseInt(this.batch.customsAmount, 10) }),
        ...(this.batch.lawsAmount && { derechosArancelarios: parseInt(this.batch.lawsAmount, 10) }),
        ...(this.batch.exchangeAmount && { tipoCambio: parseInt(this.batch.exchangeAmount, 10) }),
        ...(this.batch.minimunAmount && { montoMinimo: parseInt(this.batch.minimunAmount, 10) }),
        ...(this.batch.consignee && { consignatorio: this.batch.consignee }),
        ...(this.batch.releaseDate && { fechaLoteo: this.batch.releaseDate }),
        ...(location && location.id && {
          ubicacionMercanciaId: location.id,
          ubicacionMercanciaValor: location.value,
          ubicacionMercanciaDescripcion: location.label
        }),
        ...(quality && quality.id && {
          calidadMercanciaId: quality.id,
          calidadMercanciaValor: quality.value,
          calidadMercanciaDescripcion: quality.label
        }),
        ...(this.batch.presumptionDate && { fechaPresuncion: this.batch.presumptionDate }),
        ...(this.batch.seizureDate && { fechaIncautacion: this.batch.seizureDate }),
        ...(this.batch.law && { causaArtOrd: this.batch.law }),
        estado: newStatus,
        oficio: this.batch.trade ? 'Y' : 'N'
      };
      if (this.validations.resolution.includes(this.batch.jurisdiction)
        || this.batch.confiscation) {
        batch.fechaResolucion = this.batch.resolutionDate;
        batch.numeroResolucion = this.batch.resolutionNumber;
      }
      if (this.batch.jurisdiction === this.validations.abandon) {
        batch.numeroManifiesto = this.batch.manifestNumber;
        batch.fechaManifiesto = this.batch.manifestDate;
        batch.numeroPapeletaRecepcion = parseInt(this.batch.ballotNumber, 10);
        batch.fechaPapeleta = this.batch.ballotDate;
      }
      if (this.batch.jurisdiction === this.validations.pending) {
        batch.numeroCausa = this.batch.causeNumber;
        batch.nombreJuzgado = this.batch.courtName;
      }
      if (this.batch.check) {
        batch.numeroCertificadoVb = parseInt(this.batch.certificateNumber, 10);
        batch.fechaVb = this.batch.checkDate;
        batch.entidadVb = this.batch.entityCheck;
      }
      if (this.batch.trade) {
        batch.fechaOficio = this.batch.tradeDate;
        batch.numeroOficio = this.batch.tradeNumber;
        batch.aduanaOficio = this.batch.tradeCustom;
      }
      if (this.batch.additional) {
        batch.impuestosAdicionalesId = this.batch.additional.id;
        batch.impuestosAdicionalesValor = this.batch.additional.value;
        batch.impuestosAdicionalesDescripcion = this.batch.additional.label;
      }
      if (images.length) {
        batch.imagenes = images;
      }
      const request = {};
      if (isPreview) {
        request.params = { simular: 'si' };
      }
      let response = {};
      if (this.editBatch) {
        if (this.batch.status === batchesCodeSates.rechazado) {
          batch.estado = batchesCodeSates.creado;
        }
        batch.loteId = this.batch.loteId;
        if (isPreview) {
          this.$vs.notify({
            title: 'Danos unos segundos!',
            text: 'Estamos trabajando en la previsualización de tu archivo',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'primary',
            position: ALERT_POSITION
          });
        }
        response = await this.attemptUpdateBatch({ ...request, batch });
        this.loading = false;
      } else {
        response = await this.attemptProcessBatch({ ...request, batch });
        this.loading = false;
      }
      this.loading = false;
      if (isPreview) {
        await window.open(response.url, '_blank');
      } else {
        await this.$router.push({ name: 'batchs' });
      }
      await this.$validator.reset();
    },
    cancelBatch() {
      this.$router.push({ name: 'batchs' });
    },
    previewBatch() {
      this.processBatch(batchesCodeSates.creado, true);
    },
    async getInformation() {
      const entities = await listOptions({
        grupoOpcion: 'io.aduanas.entidades'
      });
      this.optionsEntityCheck = entities.data.opciones.map((product) => ({
        label: product.descripcion,
        id: product.opcionId,
        value: product.valor
      }));

      const locations = await listOptions({
        grupoOpcion: 'io.aduanas.almacenes'
      });
      this.optionsLocation = locations.data.opciones.map((product) => ({
        label: `${product.valor} - ${product.descripcion}`,
        id: product.opcionId,
        value: product.valor
      }));

      const holdingGroups = await ioGetHoldingGroupsCompanies({
        empresaId: this.company.id
      });
      const configurations = await getConfigurationParameters({
        parametros: 'io.aduanas.iva,io.aduanas.arancel.mercancia.nueva,io.aduanas.arancel.mercancia.usada'
      });
      this.configurations = await configurations.data.configuraciones;
      this.lotteryCustoms = holdingGroups.data.grupos
        .map((group) => ({
          label: group.nombre,
          id: group.id,
          value: group.id
        }));
    },
    mapBatchInformation(batch) {
      this.batch = {
        loteId: batch.loteId,
        jurisdiction: batch.calidadJuridicaId,
        check: batch.requiereVb === YES_APPROVAL_REQUIRED,
        clasification: batch.clasificacionLoteValor,
        measure: batch.tipoMedidaValor,
        weight: batch.pesoLote,
        measureUnit: batch.unidadMedidaValor,
        internBatch: batch.numeroInterno,
        description: batch.descripcionLote ? batch.descripcionLote : '',
        descriptionInvoice: batch.descripcionLoteFactura ? batch.descripcionLoteFactura : '',
        customsAmount: batch.valorAduanero,
        lawsAmount: batch.derechosArancelarios,
        exchangeAmount: batch.tipoCambio,
        minimunAmount: batch.montoMinimo,
        consignee: batch.consignatorio,
        releaseDate: batch.fechaLoteo,
        trade: batch.oficio === 'Y',
        location: batch.ubicacionMercanciaValor,
        quality: batch.calidadMercanciaValor,
        presumptionDate: batch.fechaPresuncion,
        seizureDate: batch.fechaIncautacion,
        law: batch.causaArtOrd,
        status: batch.estado
      };
      if (batch.fechaOficio) {
        this.batch.tradeDate = batch.fechaOficio;
        this.batch.tradeNumber = batch.numeroOficio;
        this.batch.tradeCustom = batch.aduanaOficio;
      }
      if (batch.fechaResolucion) {
        this.batch.resolutionDate = batch.fechaResolucion;
        this.batch.resolutionNumber = batch.numeroResolucion;
      }
      if (batch.numeroManifiesto) {
        this.batch.manifestNumber = batch.numeroManifiesto;
        this.batch.manifestDate = batch.fechaManifiesto;
        this.batch.ballotNumber = batch.numeroPapeletaRecepcion;
        this.batch.ballotDate = batch.fechaPapeleta;
      }
      if (batch.numeroCausa) {
        this.batch.causeNumber = batch.numeroCausa;
        this.batch.courtName = batch.nombreJuzgado;
      }
      if (batch.numeroCertificadoVb) {
        this.batch.certificateNumber = batch.numeroCertificadoVb;
        this.batch.checkDate = batch.fechaVb;
        this.batch.entityCheck = batch.entidadVb;
      }
      if (batch.impuestosAdicionalesValor) {
        this.batch.additional = batch.impuestosAdicionalesDescripcion;
      }
      this.batch.images = [];
    }
  },
  async created() {
    const { id } = this.$route.params;
    this.$vs.notify({
      title: 'Danos unos segundos!',
      text: 'Estamos buscando la información para el formulario',
      color: 'success',
      time: 5000,
      position: 'top-center'
    });
    if (id) {
      try {
        this.loading = true;
        this.editBatch = true;
        const response = await getBatch({ loteId: id });
        const batch = response.data.documentos;
        this.loading = false;
        await this.getInformation();
        this.mapBatchInformation(batch);
        await this.$validator.reset();
      } catch (e) {
        this.loading = false;
      }
    } else {
      await this.getInformation();
    }
  }
};
</script>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
